import Tip from './Tip'
export default Tip